import { __assign, __decorate, __extends, __rest } from "tslib";
import React from "react";
import { Misc, Utils } from "@singularsystems/neo-core";
import { observer } from 'mobx-react';
import CollapsableBase from '../CollapsableBase';
import { NeoReactTypes } from "../../Modules/Types";
var Alert = /** @class */ (function (_super) {
    __extends(Alert, _super);
    function Alert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconFactory = Misc.Globals.appService.get(NeoReactTypes.Components.IconFactory);
        return _this;
    }
    Alert.prototype.render = function () {
        var _a = this.props, variant = _a.variant, heading = _a.heading, show = _a.show, bindShow = _a.bindShow, autoCloseTimeout = _a.autoCloseTimeout, animateInitial = _a.animateInitial, state = _a.state, onHidden = _a.onHidden, refreshValue = _a.refreshValue, icon = _a.icon, native = __rest(_a, ["variant", "heading", "show", "bindShow", "autoCloseTimeout", "animateInitial", "state", "onHidden", "refreshValue", "icon"]);
        var className = Utils.joinWithSpaces(native.className, "alert", "alert-" + variant, "collapsable");
        if (bindShow) {
            className += " alert-dismissible";
        }
        this.shouldShow = show !== false && (!bindShow || bindShow.value);
        return (React.createElement("div", __assign({}, native, { className: className, ref: this.containerRef }),
            heading &&
                React.createElement("h6", null, heading),
            icon &&
                React.createElement("div", { className: "notification-icon-container" },
                    this.iconFactory.getIconComponent(icon),
                    React.createElement("div", null, this.props.children)),
            !icon && this.props.children,
            bindShow &&
                React.createElement("button", { type: "button", className: "close", onClick: this.onClose },
                    React.createElement("span", null, "\u00D7"))));
    };
    Alert = __decorate([
        observer
    ], Alert);
    return Alert;
}(CollapsableBase));
export default Alert;
